/**
 * Animation for CTA Cards on Hover
 **/

let lottieAnimationObserver

const loadLottie = () =>
{
    let lottieAnimation = document.querySelector("[data-animation]");

    if ("IntersectionObserver" in window)
    {
        lottieAnimationObserver = new IntersectionObserver(function(entries)
        {
            entries.forEach(function(entry)
            {
                if (entry.isIntersecting)
                {
                    // Add the lottie Script
                    let script = document.createElement('script');
                    script.src = "https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js";
                    document.getElementsByTagName('head')[0].appendChild(script);

                    // Launch the animation JS
                    animation();

                    // Stop Observing once Lottie has been loaded
                    lottieAnimationObserver.unobserve(lottieAnimation);
                }
            });
        });
        if (lottieAnimation) {
            lottieAnimationObserver.observe(lottieAnimation);
        }
    }
 }

const animation = () =>
{

	const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const playerContainers = document.querySelectorAll(".ctaAnimation");

    if (playerContainers.length && !query.matches)
    {
        playerContainers.forEach(container =>
        {


            // Do the mouseover/mouseleave on the parent so the whole block is used
            const parent = container.parentNode;
            const player = container.querySelector("lottie-player");

            parent.addEventListener('mouseover', function()
            {
                player.setDirection(1);
                player.play();
            });

            parent.addEventListener('mouseleave', function()
            {
                player.setDirection(-1);
                player.play();
            });

        });
    }
}

export { loadLottie }
